/* eslint-disable @typescript-eslint/no-redundant-type-constituents */
import {
  Link,
  type AnyRoute,
  type LinkProps,
  type RegisteredRouter,
  type RoutePaths,
} from "@tanstack/react-router"

import { cn } from "@/lib/utils"
import { Button } from "../ui/button"

type ActiveLinkExtraProps = {
  activeClassName?: string
  inactiveClassName?: string
}

export default function ActiveLink<
  TRouteTree extends AnyRoute = RegisteredRouter["routeTree"],
  TFrom extends RoutePaths<TRouteTree> | string = string,
  TTo extends string = "",
  TMaskFrom extends RoutePaths<TRouteTree> | string = TFrom,
  TMaskTo extends string = "",
>(
  props: LinkProps<TRouteTree, TFrom, TTo, TMaskFrom, TMaskTo> &
    React.RefAttributes<HTMLAnchorElement> &
    ActiveLinkExtraProps
) {
  const { activeClassName, inactiveClassName, ...linkProps } = props

  return (
    //@ts-expect-error Router Typing
    <Link preload={false} {...linkProps}>
      {({ isActive }) => {
        return (
          <Button
            variant={isActive ? "secondary" : "ghost"}
            className={cn(
              "w-full justify-start transition-all duration-200 hover:translate-x-1 focus-visible:translate-x-1 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
              isActive ? activeClassName : inactiveClassName
            )}
          >
            {typeof props.children === "function"
              ? props.children({ isActive })
              : props.children}
          </Button>
        )
      }}
    </Link>
  )
}
